import React from "react";
import styles from "./Navbar.module.css";
import logo from "../assets/logo.png"; // Importa l'immagine del logo

const Navbar = () => {
  return (
    <nav className={styles.navbar}>
      <div className={styles.logo}>
        <a href="/">
          <img src={logo} alt="Logo" className={styles.logoImage} />{" "}
          {/* Usa l'immagine come logo */}
        </a>
      </div>
      <ul className={styles.navLinks}>
        <li>
          <a href="#whatwedo">Cosa facciamo</a>
        </li>
        <li>
          <a href="#whoweare">Chi siamo</a>
        </li>
        <li>
          <a href="#contatti">Contatti</a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
